import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { works } from "@/mocks/works";

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20noir%20mystery%20cityscape%20at%20night%20with%20fog%2C%20glowing%20crimson%20and%20warm%20gold%20streetlights%2C%20silhouetted%20detective%20standing%20on%20a%20wet%20street%2C%20moody%20cinematic%20atmosphere%2C%20stylized%20manga%20illustration%2C%20deep%20shadows%2C%20dramatic%20contrast&width=1600&height=900&seq=hero-2026-hanhan&orientation=landscape"
          alt="汗汗漫画悬疑推理阅读平台首屏背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/60 to-background-50"></div>
        <div className="seal-line absolute inset-x-0 bottom-0"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-[1400px] flex-col items-center px-4 pb-16 pt-16 text-center md:px-6 md:pb-24 md:pt-28">
        <span className="inline-flex items-center gap-2 rounded-full border border-accent-300/40 bg-accent-500/10 px-4 py-1.5 text-xs font-medium text-accent-200">
          <i className="ri-flashlight-line" aria-hidden="true"></i>
          悬疑 · 推理 · 烧脑 · 反转 · 案件 · 解密
        </span>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-foreground-50 md:text-5xl">
          每一个真相
          <br className="md:hidden" />
          <span className="mystery-text"> 都藏在下一页</span>
        </h1>
        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-300 md:text-base">
          汗汗漫画悬疑推理追更专区，汇聚烧脑反转的悬疑推理佳作。剧情扑朔迷离，反转不断，
          陪你一起在线追更、破解谜案、解密真相。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#updates"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-play-circle-line" aria-hidden="true"></i>
            开始追更
          </a>
          <a
            href="#hot"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300/50 bg-background-900/40 px-7 py-3 text-sm font-semibold text-foreground-100 backdrop-blur-sm transition-colors hover:border-accent-300/60 hover:text-accent-200"
          >
            <i className="ri-fire-line" aria-hidden="true"></i>
            热门佳作
          </a>
        </div>

        {/* 分类快捷入口 */}
        <div className="mt-12 grid w-full grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group flex flex-col items-center gap-2 rounded-lg border border-background-200/50 bg-background-900/40 px-3 py-4 backdrop-blur-sm transition-colors hover:border-accent-300/50 hover:bg-background-900/70"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500/20 text-primary-300 transition-colors group-hover:bg-primary-500/35 group-hover:text-primary-200">
                <i className={`${c.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <span className="text-sm font-semibold text-foreground-100">
                {c.name}漫画
              </span>
            </Link>
          ))}
        </div>

        {/* 数据统计 */}
        <div className="mt-12 grid w-full max-w-3xl grid-cols-3 gap-4 border-t border-background-200/40 pt-8">
          {[
            { num: works.length + "+", label: "在更优质作品" },
            { num: "2000+", label: "章节持续更新" },
            { num: "120w+", label: "推理爱好者" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">
                {s.num}
              </div>
              <div className="mt-1 text-xs text-foreground-500 md:text-sm">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}